import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
import { ROLES } from '../utils/constants';
import { checkAccessRights } from '../utils/functions/accessRight';

const USER = process.env.REACT_APP_API_URL;
const ADMIN = process.env.REACT_APP_API_URL_admin;

// Define a base query with headers
const baseQuery = fetchBaseQuery({
  // ✅ เพิ่มเงื่อนไขให้อนุญาต SALE_ROLE ใช้ URL ของ ADMIN
  baseUrl: `${
    checkAccessRights(ROLES.ADMIN_ROLE) || 
    checkAccessRights(ROLES.SUPER_ADMIN_ROLE) || 
    checkAccessRights(ROLES.SALE_ROLE) 
      ? ADMIN 
      : USER
  }/log/wht`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, add the Authorization header
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

// Define the API service
export const saveLogWht = createApi({
  reducerPath: 'saveLogWht',
  baseQuery,
  endpoints: (builder) => ({
    // Use mutation for POST request
    postSaveLogWht: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body, // ส่งบอดี้ไปยัง API
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const { usePostSaveLogWhtMutation } = saveLogWht;